import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

interface WordmarkProps extends HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP: Record<NonNullable<WordmarkProps['size']>, string> = {
  sm: 'text-14',
  md: 'text-18',
  lg: 'text-32',
};

// Spec §1.1 + addendum §H — accent dot is a separate <span> so it picks up the
// live --accent token (and rebinds on theme change).
export function Wordmark({ size = 'md', className, ...rest }: WordmarkProps) {
  return (
    <span
      {...rest}
      className={clsx(
        'font-semibold tracking-[-0.04em] text-fg-primary lowercase select-none',
        SIZE_MAP[size],
        className,
      )}
      aria-label="Frame"
    >
      frame<span className="text-accent">.</span>
    </span>
  );
}
